export function getChangedValue<T>(oldValue: T, newValue: T): T {
    return JSON.stringify(oldValue) !== JSON.stringify(newValue) ? newValue : oldValue;
}
